import { render } from "./favourite-messages.vue?vue&type=template&id=0d9d298a&scoped=true"
import script from "./favourite-messages.vue?vue&type=script&lang=js"
export * from "./favourite-messages.vue?vue&type=script&lang=js"

import "./favourite-messages.vue?vue&type=style&index=0&id=0d9d298a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d9d298a"]])

export default __exports__